<template lang="pug">
div
    .block.items-center.justify-between(
        class="lg:p-0 p-4 lg:flex"
    )
        .result-filter__info.w-full.mobile-only.mb-4
            .list.flex.items-center.justify-between.mb-3.pb-3.border-b
                strong Showing data
                div.btn-primary-o.btn-small(
                    v-on:click="filterShow = !filterShow"
                ) Filter

            .list.flex.items-center.justify-between.mb-2
                span Date
                strong.monospace {{ dateRange.startDate | date}} - {{ dateRange.endDate  | date}}
            
            .list.flex.items-center.justify-between
                span Show
                strong.monospace {{ items_per_page }}

        .result-filter__action(
            v-bind:class="{'is-show' : filterShow}"
        )
            .mobile-only
                .header-filter.mb-4
                    h2 Filter
                    button(
                        v-on:click="filterShow = !filterShow"
                    )
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            .flex.items-center
                .flex.flex-wrap.items-center.justify-between
                    .relative.mr-3.field-date-time-picker
                        date-range-picker(
                            v-if="dateRange.startDate && dateRange.endDate" 
                            ref="picker" 
                            v-model="dateRange" 
                            @update="pickerUpdate($event)" 
                            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                            :date-format="dateFormat" 
                            opens="right" 
                            :ranges="default_ranges"
                            autoApply=true)
                            div(
                                slot="input" 
                                slot-scope="picker") 
                                    | {{ picker.startDate | date}} - {{ picker.endDate  | date}}

                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

                    .flex.flex-wrap.items-center
                        .field.mr-2.relative
                            select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            .mobile-only
                button.btn-primary-o.w-full.btn-large(
                    v-on:click="filterShow = !filterShow"
                ) Filter
        .block(v-if="single_monitoring_list.data && single_monitoring_list.data.length > 0")
            .flex.flex-wrap.items-center.justify-between
                .field.mr-3.relative
                //- JsonCSV(
                //-     :data="csvData"
                //-     :name="csvName"
                //-     class="btn btn-primary"
                //- )
                //-     | Download CSV

                JsonExcel.btn.btn-primary.cursor-pointer(
                    type = "csv"
                    :title="[('Monitoring History '+ (single_target_detail.target_name ? '- '+ single_target_detail.target_name : '') +' - Target Detail' ), from_date + ' - ' + to_date]"
                    :name="csvName"
                    :data="csvData"
                )
                    | Download CSV

    .table-static.w-full
        table
            thead
                tr
                    th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
            tbody
                tr(v-if="load_data_status_single_monitoring_list === 'loading'")
                    td.text-center(:colspan="tableThead.length")
                        .flex.flex-wrap.items-center.justify-center
                            Spinner(show="true" size="48")
                        
                template(v-else-if="single_monitoring_list && single_monitoring_list.data && single_monitoring_list.data.length > 0")
                    tr(v-for="(data,index) in single_monitoring_list.data" :key="data.id")
                        //- td 
                            strong {{data.multi_tracking.group_name}}
                        //- td 
                            button.flex.items-center(@click="detailTarget(data)")
                                figure.w-12.h-12.mr-4
                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="data.target.photo ? data.target.photo : getDefaultImage" @error="getDefaultImage")

                                strong.text-link {{ data.target.name }}
                        td 
                            small {{data.started_at}} - {{data.started_by.name}} 
                        td 
                            small {{data.stoped_at}} - {{data.stoped_by.name}}
                        td {{freqName(data.frequency)}}
                        td {{data.msisdn}}
                        td(:class="data.status.toLowerCase()==='started' ? 'status-active' : 'status-inactive'") 
                            span {{ data.status }}
                tr(v-else)
                    td.text-center(:colspan="tableThead.length") No Data Available
        .mt-5
        vue-ads-pagination(
            :total-items="total_data"
            :items-per-page="items_per_page"
            :page="page"
            :max-visible-pages="5"
        )
            template(slot="buttons" slot-scope="props")
                vue-ads-page-button(
                    v-for="(button, key) in props.buttons"
                    :key="key"
                    v-bind="button"
                    :class="{'bg-yellow-dark': button.active}"
                    @page-change="page = button.page"
                    @range-change="start = button.start; end = button.end"
                )
</template>

<script>
import { mapState } from 'vuex';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import { encrypt,decrypt } from '@/util/crypto';
import JsonCSV from 'vue-json-csv';
import JsonExcel from "vue-json-excel";

export default {
    name: 'STMonitoringHistory',
    components: {
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        DateRangePicker,
        JsonCSV,
        JsonExcel,
    },
    data() {
        return {
            filterShow: false,
            tableThead: [
                {
                    name: 'Start',
                },{
                    name: 'Stop',
                },{
                    name: 'Frequency',
                },{
                    name: 'MSISDN',
                },{
                    name: 'Status',
                }
            ],
            
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,

            from_date: '',
            to_date: '',

            dateRange: {
                startDate: '',
                endDate: '',
            },
            default_ranges: {
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },
            defaultImage: this.$store.getters.getDefaultImage,
            freqOpt: this.$store.getters.getFreqMonitoring,
            // csvName: 'monitoring_history_list_'+moment().format('YYYY-MM-DD_HH:mm:ss')+'.csv',
            csvData: [],

            isAstro: process.env.VUE_APP_ASTRO,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_single_monitoring_list',
            'single_monitoring_list',
            'single_target_detail',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        key() {
            return decrypt(this.$route.params.key).split('&&');
        },
        csvName() {
            return 'monitoring_history_list'+ (this.single_target_detail.target_name ? '-'+ (this.single_target_detail.target_name).toLowerCase().replace(' ', '_') : '') + '-target_detail' + moment().format('YYYY-MM-DD_HH:mm:ss')+'.csv';
        },
    },
    watch: {
        single_monitoring_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);

                if (newData.data && newData.data.length > 0) {
                    this.getDataCsv(newData.data);
                }
            } else {
                this.total_data = 0;
            }
            // if (this.single_monitoring_list.data && this.single_monitoring_list.data.length > 0) {
            //     this.getDataCsv(this.single_monitoring_list.data);
            // }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
        // id() {
        //     if (this.id != undefined) {
        //         this.getData();
        //     }
        // },
        route_name(newData, oldData) {
            if (newData === 'PageTargetDetailHome') {
                if (oldData !== 'PageTargetDetailHome') {
                    // this.dateRange.startDate = moment().toDate();
                    // this.dateRange.endDate = moment().toDate();

                    // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    const default_date = this.$store.getters.getDefaultDate();

                    this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                    this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                    this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
            
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setSingleMonitoringList', {});
                    this.$store.commit('setLoadDataStatusSingleMonitoringList', 'loading');
                }

                this.getData();
            }
        },
        id() {},
        key() {},
        csvName() {},
    },
    methods: {
        freqName(frequency) {
            var freq = this.freqOpt.filter( val => val.value == frequency )
            if (freq.length > 0) {
                return freq[0].name
            } else {
                return '-'
            }

        },
        datetimeFormat(datetime) {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
        },
        /* eslint-disable no-unused-vars */
        dateFormat (classes, date) {
            if (!classes.disabled) {
                // console.log('on dateFormat')
                // console.log(moment(date.getTime())._d)

                // classes.disabled = date.getTime() > new Date();
                classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
            }
            return classes;
        },
        detailMaps(id) {
            console.log(id)
        },
        getData() {
            this.$store.dispatch('getSingleMonitoringList', [this.id, this.key[0], this.items_per_page, (this.page + 1), this.keyword, this.from_date, this.to_date]);

            // if (this.single_monitoring_list.data && this.single_monitoring_list.data.length > 0) {
            //     this.getDataCsv(this.single_monitoring_list.data)
            // }

            if (this.single_monitoring_list.total_page && this.single_monitoring_list.total_page > 1) {
                // console.log(this.single_monitoring_list.total_page)
                this.pagination();
            }
        },
        getDataCsv(data) {
            this.csvData = data.map((item) => {
                return {
                    started_at: item.started_at?item.started_at:'-',
                    started_by: item.started_by?item.started_by.name:'-',
                    stoped_at: item.stoped_at?item.stoped_at:'-',
                    stoped_by: item.stoped_by?item.stoped_by.name :'-',
                    frequency: item.frequency?this.freqName(item.frequency):'-',
                    msisdn: item.msisdn?item.msisdn:'-',
                    status: item.status?item.status:'-',
                };
            })
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setSingleTrackingList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        async pickerUpdate(e) {
            // console.log('========= DateRangePicker on update')
            // console.log(e)

            let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;

            if (this.isAstro !== 'true' && ranges > 7) {
                const default_date = this.$store.getters.getDefaultDate();

                // this.dateRange.startDate = moment().toDate();
                // this.dateRange.endDate = moment().toDate();

                // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.$swal.fire({
                    icon: 'error',
                    title: 'Date range is not more than 7 days!',
                    text: 'Your date range is ' + ranges + ' days.',
                    // confirmButtonText: 'Yes!',
                    // confirmButtonColor: '#DD6B55',
                    // showCancelButton: true,
                    // allowOutsideClick: false,
                })

                // return;
            } else {
                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.getData();
            }
        },
        detailTarget(data) {
            var msisdn = data.msisdn
            this.$router.push({ name: 'PageTargetDetailHome', params: { id: data.target.id ,key: encrypt(msisdn + '&&msisdn') }  })
        },
    },
    filters: {
        date: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
    },
    mounted() {
        // console.log('=================== mounted mp')
        // console.log(this.route_name)
        // console.log(this.id)
        // console.log(this.$route.params.key)
        // console.log(decrypt(this.$route.params.key))
        // console.log(this.key)
        // console.log(this.key[0])

        if (this.route_name === 'PageTargetDetailHome') {
            // reset date filter
            // this.dateRange.startDate = moment().toDate();
            // this.dateRange.endDate = moment().toDate();

            // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

            const default_date = this.$store.getters.getDefaultDate();

            this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
            this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

            this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

            // this.pagination();
            this.getData();
        }
    },
}
</script>

<style lang="sass">
    .draw-area
        height: 500px
    .cell-info-window
        vertical-align: top
</style>